export default function playVideoInView() {
  function init() {
    const video = document.querySelector(".video-module");

    const config = {
      // rootMargin: "0px 0px 30% 0px",
      threshold: ["0.55", "1"],
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const videoSrc = document.querySelector(".video-module-video");

        if (entry.isIntersecting) {
          videoSrc.play();
        } else {
          videoSrc.pause();
        }
      });
    }, config);

    observer.observe(video);
  }

  const isPresent = document.getElementsByClassName("video-module");
  if (isPresent.length > 0) {
    init();
  }
}
